import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Api from '../../../_helpers/Api'
import loader from '../../../assets/img/loader.svg'
import Skeleton from 'react-loading-skeleton'
import { fromInfo, trans } from '../../../_providers/Translation'
import Filter from './partials/FilterStats'
import PartsPages from '../../partials/PartsPages'
import PartsStats from './partials/PartsStats'
import Help from '../../partials/Help'
import GroupedBarChart from '../../partials/GroupedBarChart'
import { getPaletteColor } from '../../partials/chartTheme'

let timeout

function Stats(props) {

    const params = useParams()
    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        loading: true,
        data: {
            dates: [],
            categories: []
        },
        filter: {},
        setFilter: false,
        update: false,
        summary: false,
        allowDetails: false,
    })

    const partsRef = useRef(null)

    useEffect(() => {
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                start: searchParams.get('start') || '',
                end: searchParams.get('end') || '',
                group: searchParams.get('group') || '',
            },
            update: new Date().getTime()
        }))

    }, [location.search])

    // useEffect(() => {
    //     console.log(state.filter);
    // }, [state.filter]);

    useEffect(() => {
        if (state.setFilter) {
            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])

    useEffect(() => {

        if (!state.data.dates) {
            return
        }

        const labels = state.data.dates.map(d => d.label)

        const formatValue = val => `${Number(val || 0).toFixed(2)} ${state.data.currency || ''}`.trim()

        let seriesOrdered
        let seriesStock

        // обобщена
        if (state.summary) {
            seriesOrdered = [{
                name: trans('random.income'),
                ...getPaletteColor(2),
                data: state.data.dates.map(d => d.ordered_gross),
                valueFormatter: formatValue,
            }]

            seriesStock = [{
                name: trans('random.income'),
                ...getPaletteColor(2),
                data: state.data.dates.map(d => d.stock_gross),
                valueFormatter: formatValue,
            }]
        }
        // по категории
        else {
            seriesOrdered = state.data.categories.map((c, ci) => ({
                name: c.name,
                ...getPaletteColor(ci),
                data: state.data.dates.map(d => c.dates[d.date].ordered_gross),
                valueFormatter: formatValue,
            }))

            seriesStock = state.data.categories.map((c, ci) => ({
                name: c.name,
                ...getPaletteColor(ci),
                data: state.data.dates.map(d => c.dates[d.date].stock_gross),
                valueFormatter: formatValue,
            }))
        }

        setState(prev => ({
            ...prev,
            chartLabels: labels,
            chartOrdered: seriesOrdered,
            chartStock: seriesStock,
        }))

    }, [state.data, state.summary])

    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'accounts/parts-with-invoices'

        Object.entries(state.filter).map(filter => {
            url += (url.indexOf('?') > -1 ? '&' : '?') + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                // let label = trans('calendar.month');

                // let chart = [
                //     [label, trans('tabs.reservations')],
                // ];

                // res.data.dates.map(d => {
                //     let arr = [
                //         d.label, d.ordered
                //     ];

                //     chart.push(arr);
                // })

                setState(prev => ({
                    ...prev,
                    data: res.data,
                    // chart: chart,
                    filter: {
                        ...prev.filter,
                        group: res.data.group,
                        start: res.data.start,
                        end: res.data.end
                    },
                    loading: false,
                    summary: res.data.categories.length === 0 ? true : prev.summary,
                    allowDetails: res.data.categories.length === 0 ? false : true
                }))
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleSearch = (key, val, delay = 300) => {

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            setFilter: new Date().getTime()
        }))
    }

    const toggleSummaryData = val => {
        setState(prev => ({
            ...prev,
            summary: val
        }))
    }

    const showParts = (categoryId, start, end, tab = null) => {
        partsRef.current.open(categoryId, start, end, tab)
    }

    return (
        <>
            <PartsStats
                ref={partsRef}
            />

            <div className="wrapper">

                <div className="top-part">
                    <div className="left">
                        <h1 className="page-heading">
                            {trans('headings.stats')} <Help>{fromInfo('parts.stats')}</Help>
                        </h1>
                        <p className="page-subheading">
                            {trans('subheadings.partsIncomes')}
                        </p>
                    </div>
                    <div className="right">

                    </div>
                </div>


                <div className="pannel">
                    <Filter
                        allowDetails={state.allowDetails}
                        filter={state.filter}
                        summary={state.summary}
                        handleSearch={handleSearch}
                        toggleSummaryData={toggleSummaryData}
                    />

                    <hr />

                    {state.loading
                        ?
                        <img className="loader" src={loader} />
                        :
                        <>
                            <div className="row">
                                <div className="col">
                                    <div className='pannel'>
                                        <div className="head">
                                            <h3>{trans('headings.orderedPartsWithInvoices')}</h3>
                                            {!state.summary &&
                                                <ul className="chart-legend">
                                                    {(state.chartOrdered || []).map(s => (
                                                        <li key={s.name}>
                                                            <span style={{
                                                                background: `linear-gradient(to bottom, ${s.color1}, ${s.color2})`
                                                            }} />
                                                            {s.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>
                                        {state.loading
                                            ?
                                            <Skeleton height={360} />
                                            :
                                            <GroupedBarChart
                                                labels={state.chartLabels || []}
                                                series={state.chartOrdered || []}
                                                barWidth={20}
                                                roundedBottom
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="col">
                                    <div className='pannel'>
                                        <div className="head">
                                            <h3>{trans('headings.stockPartsWithInvoices')}</h3>
                                            {!state.summary &&
                                                <ul className="chart-legend">
                                                    {(state.chartStock || []).map(s => (
                                                        <li key={s.name}>
                                                            <span style={{
                                                                background: `linear-gradient(to bottom, ${s.color1}, ${s.color2})`
                                                            }} />
                                                            {s.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>
                                        {state.loading
                                            ?
                                            <Skeleton height={360} />
                                            :
                                            <GroupedBarChart
                                                labels={state.chartLabels || []}
                                                series={state.chartStock || []}
                                                barWidth={20}
                                                roundedBottom
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                            <div
                                className='row'

                            >
                                <div className='col'>
                                    <div
                                        className='pannel'

                                    >
                                        <div className="table-scroller">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            {trans('tables.category')}
                                                        </th>
                                                        {state.data.dates.map((d, i) =>
                                                            <th key={'th-' + i} className="right">
                                                                {d.label}
                                                            </th>
                                                        )}
                                                        <th className="right">
                                                            {trans('tables.total')}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {state.data.categories.map(c =>
                                                        <tr key={'c-' + c.id}>
                                                            <td>
                                                                {c.name}
                                                            </td>
                                                            {state.data.dates.map((d, i) =>
                                                                <td
                                                                    key={'td-' + i}
                                                                    className="right clickable"
                                                                    onClick={() => showParts(c.id, d.start_date, d.end_date)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {c.dates[d.date].gross_formatted}
                                                                </td>
                                                            )}
                                                            <td className="right">
                                                                {c.gross_formatted}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    <tr>
                                                        <td>
                                                            {trans('tables.total')}
                                                        </td>
                                                        {state.data.dates.map((d, i) =>
                                                            <td
                                                                key={'totals-' + i}
                                                                className="right clickable"
                                                                onClick={() => showParts(null, d.start_date, d.end_date)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {d.gross_formatted}
                                                            </td>
                                                        )}
                                                        <td className="right">
                                                            {state.data.gross_formatted}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    }
                </div>
            </div>

        </>
    )
}

export default Stats